import React from 'react';
import { AlertTriangle, CheckCircle2, CloudOff, Loader2, LogIn, Smartphone } from 'lucide-react';

function timeAgo(ms) {
  if (!ms) return null;
  return new Date(ms).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
}

// Where the therapist's last edit lives right now. The device line is the one
// that matters for "will I lose this": once it says saved, closing the tab is safe.
export default function SaveStatus({ local, sync, pendingCount, compact = false }) {
  const deviceOk = local.available !== false && local.state !== 'error';
  let serverIcon;
  let serverText;
  let serverTone = 'text-slate-600';

  if (sync.state === 'syncing') {
    serverIcon = <Loader2 className="h-3.5 w-3.5 animate-spin" />;
    serverText = 'Syncing…';
  } else if (pendingCount === 0 && (sync.state === 'synced' || sync.state === 'idle') && sync.lastSyncedAt) {
    serverIcon = <CheckCircle2 className="h-3.5 w-3.5 text-emerald-600" />;
    serverText = `Synced ${timeAgo(sync.lastSyncedAt)}`;
  } else if (sync.state === 'auth') {
    serverIcon = <LogIn className="h-3.5 w-3.5" />;
    serverText = 'Sign in to sync';
    serverTone = 'text-amber-700';
  } else if (sync.state === 'offline') {
    serverIcon = <CloudOff className="h-3.5 w-3.5" />;
    serverText = pendingCount ? `Offline · ${pendingCount} waiting to sync` : 'Offline';
    serverTone = 'text-amber-700';
  } else if (sync.state === 'error' || sync.state === 'denied') {
    serverIcon = <AlertTriangle className="h-3.5 w-3.5" />;
    serverText = pendingCount ? `Sync failed · ${pendingCount} waiting` : 'Sync failed';
    serverTone = 'text-red-700';
  } else if (pendingCount) {
    serverIcon = <Loader2 className="h-3.5 w-3.5" />;
    serverText = `${pendingCount} waiting to sync`;
  } else {
    serverIcon = <CheckCircle2 className="h-3.5 w-3.5 text-emerald-600" />;
    serverText = 'Synced';
  }

  return (
    <div className={`flex ${compact ? 'flex-col gap-0.5' : 'flex-wrap items-center gap-x-3 gap-y-1'} text-xs`}
      role="status" aria-live="polite">
      <span className={`inline-flex items-center gap-1 ${deviceOk ? 'text-slate-600' : 'text-red-700 font-medium'}`}>
        {deviceOk ? <Smartphone className="h-3.5 w-3.5" /> : <AlertTriangle className="h-3.5 w-3.5" />}
        {deviceOk ? (local.state === 'saving' ? 'Saving on this device…' : 'Saved on this device') : 'Not saving on this device'}
      </span>
      <span className={`inline-flex items-center gap-1 ${serverTone}`}>
        {serverIcon}
        {serverText}
      </span>
    </div>
  );
}
